import Image from "components/atoms/Image";
import Text from "components/atoms/Text";
import { default as Carousel, default as CarouselItem } from "components/molecules/Carousel";
import { Grid as GridLayout } from "components/organisms/Grid";
import { BASE_URL } from "constants/env";
import { maxQuery, SizeMax } from "constants/media";
import React, { useMemo } from "react";
import styled, { css } from "styled-components/macro";
import { Grid, Navigation, SwiperOptions } from "swiper";
import "swiper/modules/grid/grid.scss"; // Pagination module
import { SwiperSlide } from "swiper/react";

import "./index.scss";

interface MethodServiceProps {
  methods: any;
}

const MethodService: React.FC<MethodServiceProps> = ({
  methods,
}: MethodServiceProps) => {
  const originalClass = "m-methodservice";

  const options = useMemo(() => ({
    speed: 500,
    spaceBetween: 32,
    breakpoints: {
      320: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
        grid: {
          rows: 2,
          fill: 'row'
        },
      },
      480: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
        grid: {
          rows: 2,
          fill: 'row'
        },
      },
      768: {
        slidesPerView: 2,
        slidesPerGroup: 1,
        spaceBetween: 20,
        grid: {
          rows: 2,
          fill: 'row'
        },
      },
      992: {
        slidesPerView: 3,
        slidesPerGroup: 1,
        spaceBetween: 20,
        grid: {
          rows: 2,
          fill: 'row'
        },
      },
      1200: {
        slidesPerView: 4,
        slidesPerGroup: 1,
        spaceBetween: 20,
        grid: {
          rows: 2,
          fill: 'row'
        },
      },
    },
    autoplay: true,
    shouldSwiperUpdate: true,
    pagination: false,
    rebuildOnUpdate: true,
    hideNavigationAt: { max: SizeMax.Small },
    grid: {
      rows: 2,
      fill: 'row'
    },
    modules: [Grid, Navigation]
  } as SwiperOptions), []);

  return (
    <div className={originalClass}>
      <div className={`${originalClass}-desktop`}>
        <GridLayout>
          <Carousel
            customParams={options}
          >
            {methods.map((m: any, i: number) => (
              <SwiperSlide key={i.toString()}>
                <CarouselItem key={`${i}-id`}>
                  <div className={`${originalClass}_item`}>
                    <Image src={`${BASE_URL}${m.image}`} alt={m.text} />
                    <div className={`${originalClass}_item_title`}>
                      <TextExtended modifiers={["dark"]} content={m.text} />
                    </div>
                    {m.description && (<div className={`${originalClass}_item_description`} dangerouslySetInnerHTML={{ __html: m.description }} />)}
                  </div>
                </CarouselItem>
              </SwiperSlide>
            ))}
          </Carousel>
        </GridLayout>
      </div>
    </div >
  );
};

MethodService.defaultProps = {};

const TextExtended = styled(Text)`
  ${maxQuery(
  SizeMax.Small,
  css`
      font-size: 12px;
    `,
)}
`;

export default MethodService;
